import type { ForgeExtensionParameters } from '../types';

export const getConfig = ({ config, guestParams }: ForgeExtensionParameters) =>
	guestParams || config;

export const transformConfigBefore = (parameters: ForgeExtensionParameters) =>
	getConfig(parameters);
export const transformConfigAfter = (parameters: any) => ({ guestParams: parameters });
